/**
 * cart-add-toast.js
 * ================================================================
 * カート追加通知（PC: 中央モーダル / SP: ボトムシート）
 * ================================================================
 *
 * 【背景】
 *   カートドロワー（sections/cart-drawer.liquid）を無効化しているため、
 *   カート追加後のフィードバックをこのファイルが担っている。
 *   2026-08-19 に、旧「右上の小さなトースト（3秒で自動消滅・リンク1本）」から
 *   @cosme SHOPPING 型の確認 UI（追加内容＋カート概要＋CTA 2本）へ変更した。
 *
 * 【仕様】
 *   - 表示位置   : PC = 画面中央モーダル / SP(767.98px以下) = ボトムシート
 *   - 背景       : オーバーレイで暗転。タップで閉じる。body のスクロールをロック
 *   - 自動クローズ: なし（CTA を押させる UI のため）
 *   - 閉じ操作   : × / オーバーレイ / 「お買い物を続ける」/ Esc / SPは下スワイプ
 *   - CTA        : 「カートへ進む」→ /cart（routes.cart_url）
 *   - 表示内容   : 追加された全行をリスト表示
 *                  （画像 / ブランド / 商品名＋バリアント / 単価＋税込 /
 *                    今回追加した数量 / 行小計 / 商品オプション）
 *                  ＋カート概要（点数 / 小計 / 割引 / 合計 / 送料無料まであと）
 *
 * 【表示条件】
 *   - カート追加によって「数量が増えた行」がある時のみ表示する。
 *     数量変更・削除・EasyPoints のポイント再発行など数量が動かない
 *     cartUpdate では表示しない。
 *   - 0 円の特典商品（properties._bonus_block_id 付き、または価格 0）は
 *     自動追加のため通知対象から除外する。除外後に対象が 0 件なら表示しない。
 *   - カートページ・チェックアウトでは読み込み直後に return して無効化する。
 *
 * 【「今回追加した数量」の求め方（重要）】
 *   直前のカート状態（行キー→数量）のスナップショットと、cartUpdate で渡される
 *   新しいカートの差分を取る。これが唯一定義上正しい「追加分」になる。
 *     - 初期スナップショット: DOM のカート点数が 0 なら空オブジェクト。
 *       0 以外の場合のみ idle タイミングで /cart.js を 1 回取得して構築する
 *       （LCP を邪魔しないため。旧実装のフォールバック処理を踏襲）。
 *     - スナップショットが未確立のまま追加が起きた場合は、
 *       /cart/add.js のレスポンス（product-ajax:added イベント）に含まれる
 *       quantity を暫定値として使い、その行の現在数量を上限にクランプする。
 *       ※ /cart/add.js の quantity が「追加分」か「追加後の行合計」かは【未確認】。
 *         そのため差分計算を主、レスポンス値をフォールバックとしている。
 *
 * 【送料無料しきい値】
 *   window.CartAddToastConfig.freeShippingMinimum（= settings.free_shipping_minimum_amount）
 *   を「通貨の主単位（円）」として扱い、window.Shopify.currency.rate を掛けている。
 *   これは assets/cart.js の FreeShippingGoal クラスと同じ扱い方に合わせたもの。
 *   （snippets/free-shipping-goal.liquid では変数名が *_in_cents になっているが、
 *     JS 側は主単位として比較しているため、命名が実態と合っていない。）
 *   判定に使う金額は cart.items_subtotal_price（= 行小計合計）。
 *   ※ ショップの実際の送料無料条件とテーマ設定値が一致しているかは【未確認】。
 *
 * 【ブランド名の取得方法】
 *   商品カード（snippets/card-product.liquid）と同じロジックを使う。
 *   すなわち snippets/product-collection-title-custom.liquid の type: 'brand'
 *   （= metafields.custom.brand が true のコレクションのタイトル）。
 *   product.collections は /cart.js に含まれないため、下記の裏方セクションから受け取る。
 *   product.vendor は使わない（商品カードも vendor を使っていない）。
 *   該当コレクションが無い商品はブランド行を出さない（商品カードと同じ挙動）。
 *
 * 【獲得ポイントの取得方法】
 *   EasyPoints の獲得ポイントは product.tags（no-easy-points）と
 *   product.collections（easy-points-point-exclusion / loyalty.bonus_points /
 *   loyalty.tax_override_percentage）に依存する（snippets/epi_product_points.liquid）。
 *   これらは /cart.js に含まれないため JS では正しい値を計算できない。
 *   そこで Liquid で描画済みの値を裏方セクション
 *   sections/cart-add-toast-data.liquid から読み取る方式にしている。
 *     1. 同セクションが cart:grouped-sections に自分の id を登録するため、
 *        /cart/add.js のレスポンス sections に再描画HTMLが入り、
 *        cartUpdate の cart.sections 経由で追加リクエストなしに受け取れる。
 *     2. 入っていない場合のみ ?sections=<id> で取得し、開いているモーダルに後から差す。
 *   読み取りは textContent のみ。裏方セクションは data-loyal-* / epi-point-value を
 *   一切出力しないため、EasyPoints SDK の DOM 全体走査
 *   （getExcludedCost() / getTotalBonusPoints(document)）に干渉しない。
 *   詳細は sections/cart-add-toast-data.liquid の冒頭コメント参照。
 *
 * 【表示値の一致について】
 *   モーダルのポイント値は sections/cart-add-toast-data.liquid が計算した値。
 *   カートページ・商品ページの表示値は EasyPoints のアプリ埋め込み SDK が
 *   再計算して上書きしており、その丸めは四捨五入（実測2件から判定。詳細は同セクション参照）。一方 EasyPoints 純正
 *   スニペット（epi_product_points / epi_cart_total_points）の Liquid 計算は ceil。
 *   そのため純正の描画値をそのまま読むと必ず +1 ずれる（実測: カート226 / 通知227）。
 *   現在は裏方セクション側で「純正と同じ式・丸めのみ round」で計算し直して一致させている。
 *   丸めを変える場合は同セクションの `| round` 2 箇所を差し替える。
 *   桁区切りもカートページと同じ snippets/epi_format_number.liquid を通している。
 *   なお純正スニペット自体、行ごとの値は単価ベース、合計は行合計ベースで式が異なるため、
 *   行の値を足し上げても合計とは一致しない（カートページも同じ）。
 *
 * 【空 div が消える問題（重要）】
 *   assets/theme.css に
 *     div:empty:not(.fixed-overlay, .bg-overlay, .empty-space, .drawer__body, .no-empty)
 *       { display: none; }
 *   があるため、中身が空の div は消える。オーバーレイ・グラバー等の空 div には
 *   テーマ側の除外クラス .no-empty を必ず付ける（付け忘れると背景の暗転が出ない）。
 *
 * 【依存】
 *   - FoxTheme.pubsub / PUB_SUB_EVENTS.cartUpdate（assets/theme.js）
 *   - FoxTheme.Currency.formatMoney, FoxTheme.settings.moneyFormat（同上）
 *   - window.CartAddToastConfig（layout/theme.liquid のインライン設定）
 *   - assets/cart-add-toast.css（見た目。トークンは同ファイル冒頭）
 *   - body のスクロールロックはテーマ既存クラス .body-no-scrollbar を使用
 *
 * 【表示項目の増減】
 *   下部の OPTIONS を true/false で切り替える。文言は LABELS にまとめてある。
 *
 * 最終更新: 2026-08-19
 * ================================================================
 */
(function () {
  'use strict';

  /* ============================================================
     無効化するページ
  ============================================================ */
  var path = window.location.pathname;
  if (/^\/cart(\/|$|\?)/.test(path) || /^\/checkouts?\//.test(path)) {
    return;
  }

  var CONFIG = window.CartAddToastConfig || {};

  /* ============================================================
     表示オプション（項目の増減はここで行う）
  ============================================================ */
  var OPTIONS = {
    showBrand: true, // ブランド名（裏方セクション経由。商品カードと同じロジック）
    showUnitPrice: true, // 単価
    showQuantity: true, // 今回追加した数量
    showLineTotal: true, // 行小計（数量 2 以上のときだけ出す）
    showProperties: true, // 商品オプション（先頭が _ のキーは除外）
    showPoints: true, // 商品ごとの獲得ポイント（EasyPoints）
    showTotalPoints: true, // カート合計の獲得予定ポイント（EasyPoints）
    showCartSummary: true, // カート概要（点数 / 小計 / 割引 / 合計）
    excludeBonusFromCount: true, // 点数からご購入特典の自動追加分を除く
    showFreeShippingGoal: true, // 送料無料まであと
    maxItemsToList: 5, // これを超える行数は「他 N 点」に集約
    enableSwipeToClose: true // SP の下スワイプで閉じる
  };

  var LABELS = {
    title: '商品がカートに追加されました',
    close: '閉じる',
    continueShopping: 'お買い物を続ける',
    goToCart: 'カートへ進む',
    price: '販売価格：',
    quantity: '数量：',
    lineTotal: '小計：',
    points: '獲得ポイント：',
    tax: '税込',
    more: '他 {count} 点をカートに追加しました',
    summaryCount: 'カート内の商品',
    summaryCountUnit: '点',
    summarySubtotal: '小計（税込）',
    summaryDiscount: '割引',
    summaryTotal: '合計（税込）',
    summaryPoints: '獲得予定ポイント',
    goalRemaining: '送料無料まであと {amount}',
    goalDone: '送料無料が適用されます'
  };

  var ROOT_ID = 'cart-add-toast';
  var MOBILE_QUERY = '(max-width: 767.98px)';
  var SWIPE_CLOSE_DISTANCE = 90; // これ以上引き下げたら閉じる（px）
  var SWIPE_CLOSE_VELOCITY = 0.55; // これ以上の速度なら距離が短くても閉じる（px/ms）

  var root = null;
  var panelEl = null;
  var bodyEl = null;
  var itemsEl = null;
  var summaryEl = null;
  var lastFocused = null;

  // 直前のカート状態（行キー → 数量）。null は「未確立」
  var snapshot = null;
  // /cart/add.js のレスポンス（スナップショット未確立時のフォールバック用）
  var pendingAdd = null;
  var pendingAddTimer = null;
  // 裏方セクションから受け取った値
  //   { brands: {key: 'ルベル'}, points: {key: '49 pt (2%還元)'}, total: '123 pt' }
  var sectionData = null;
  // セクションHTMLの追加取得が二重に走らないようにするためのフラグ
  var sectionFetching = false;

  /* ============================================================
     ユーティリティ
  ============================================================ */
  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function money(cents) {
    var amount = Number(cents) || 0;
    if (window.FoxTheme && FoxTheme.Currency && typeof FoxTheme.Currency.formatMoney === 'function') {
      var format = (FoxTheme.settings && FoxTheme.settings.moneyFormat) || undefined;
      return FoxTheme.Currency.formatMoney(amount, format);
    }
    // テーマ JS が未読込のときの保険
    return '¥' + Math.round(amount / 100).toLocaleString('ja-JP');
  }

  // Shopify CDN の画像に width パラメータを付けて縮小版を取る
  function thumbUrl(url, width) {
    if (!url) return '';
    try {
      var parsed = new URL(url, window.location.origin);
      parsed.searchParams.set('width', String(width));
      return parsed.toString();
    } catch (e) {
      return url;
    }
  }

  function cartUrl() {
    if (CONFIG.cartUrl) return CONFIG.cartUrl;
    if (window.FoxTheme && FoxTheme.routes && FoxTheme.routes.cart_url) return FoxTheme.routes.cart_url;
    return '/cart';
  }

  function isMobile() {
    return window.matchMedia(MOBILE_QUERY).matches;
  }

  // 0 円の特典商品（自動追加）は通知対象外
  function isBonusItem(item) {
    var props = item.properties || {};
    if (props._bonus_block_id) return true;
    if (Number(item.final_price) === 0 || Number(item.price) === 0) return true;
    return false;
  }

  function buildSnapshot(cart) {
    var map = {};
    if (cart && cart.items) {
      cart.items.forEach(function (item) {
        map[item.key] = item.quantity;
      });
    }
    return map;
  }

  function displayName(item) {
    var title = item.product_title || item.title || '';
    var variant = item.variant_title;
    if (variant && variant !== 'Default Title') {
      title = title + ' / ' + variant;
    }
    return title;
  }

  function visibleProperties(item) {
    var props = item.properties || {};
    var out = [];
    Object.keys(props).forEach(function (key) {
      if (key.indexOf('_') === 0) return;
      var value = props[key];
      if (value === null || value === '' || typeof value === 'undefined') return;
      out.push({ key: key, value: value });
    });
    return out;
  }

  /* ============================================================
     DOM 構築（初回のみ）
  ============================================================ */
  function buildRoot() {
    if (root) return root;

    root = document.createElement('div');
    root.id = ROOT_ID;
    root.className = 'cart-add-toast';
    root.setAttribute('role', 'dialog');
    root.setAttribute('aria-modal', 'true');
    root.setAttribute('aria-labelledby', ROOT_ID + '-title');
    root.innerHTML = [
      '<div class="cart-add-toast__overlay no-empty" data-cat-close></div>',
      '<div class="cart-add-toast__dialog">',
      '  <button type="button" class="cart-add-toast__close" data-cat-close aria-label="' +
        escapeHtml(LABELS.close) +
        '">',
      '    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" aria-hidden="true"><path d="M5 5l14 14M19 5L5 19"/></svg>',
      '  </button>',
      '  <div class="cart-add-toast__panel">',
      '    <p class="cart-add-toast__title" id="' + ROOT_ID + '-title">' + escapeHtml(LABELS.title) + '</p>',
      '    <div class="cart-add-toast__body">',
      '      <ul class="cart-add-toast__items"></ul>',
      '      <div class="cart-add-toast__summary-slot no-empty"></div>',
      '    </div>',
      '    <div class="cart-add-toast__actions">',
      '      <button type="button" class="cart-add-toast__btn cart-add-toast__btn--ghost" data-cat-close>' +
        escapeHtml(LABELS.continueShopping) +
        '</button>',
      '      <a href="' +
        escapeHtml(cartUrl()) +
        '" class="cart-add-toast__btn cart-add-toast__btn--primary">' +
        escapeHtml(LABELS.goToCart) +
        '</a>',
      '    </div>',
      '    <div class="cart-add-toast__handle no-empty" aria-hidden="true"></div>',
      '  </div>',
      '</div>'
    ].join('');

    document.body.appendChild(root);

    panelEl = root.querySelector('.cart-add-toast__panel');
    bodyEl = root.querySelector('.cart-add-toast__body');
    itemsEl = root.querySelector('.cart-add-toast__items');
    summaryEl = root.querySelector('.cart-add-toast__summary-slot');

    root.addEventListener('click', function (event) {
      var closer = event.target.closest ? event.target.closest('[data-cat-close]') : null;
      if (closer) {
        event.preventDefault();
        hide();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && root.classList.contains('is-open')) {
        hide();
      }
    });

    if (OPTIONS.enableSwipeToClose) {
      setupSwipe();
    }

    return root;
  }

  /* ============================================================
     描画
  ============================================================ */
  /* ============================================================
     裏方セクションからの値（ブランド名 / 獲得ポイント）
     sections/cart-add-toast-data.liquid が描画したHTMLから
     テキストだけを読み取る。詳細はファイル冒頭のコメント参照。
  ============================================================ */

  // 「獲得ポイント：49 pt (2%還元)」→「49 pt (2%還元)」
  function stripPointsLabel(text) {
    return String(text || '')
      .replace(/\s+/g, ' ')
      .replace(/^\s*獲得ポイント\s*[:：]?\s*/, '')
      // 「49 pt(1%還元)」のように詰まる場合があるので括弧の前に空白を入れる
      .replace(/(\S)\(/, '$1 (')
      // 「126pt」→「126 pt」
      .replace(/(\d)([A-Za-zぁ-んァ-ヶ一-龠])/, '$1 $2')
      .trim();
  }

  function parseSectionHtml(html) {
    if (!html) return null;

    var parsed;
    try {
      parsed = new DOMParser().parseFromString(html, 'text/html');
    } catch (e) {
      return null;
    }

    var data = { brands: {}, points: {}, total: '' };

    parsed.querySelectorAll('[data-cat-brand-line]').forEach(function (node) {
      var key = node.getAttribute('data-cat-line');
      if (!key) return;
      var brand = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (brand) data.brands[key] = brand;
    });

    parsed.querySelectorAll('[data-cat-points-line]').forEach(function (node) {
      var key = node.getAttribute('data-cat-line');
      if (!key) return;
      var value = stripPointsLabel(node.textContent);
      // 値が取れない場合（'-' 等）は採用しない
      if (!value || value === '-') return;
      data.points[key] = value;
    });

    var totalNode = parsed.querySelector('[data-cat-points-total]');
    if (totalNode) {
      var totalValue = stripPointsLabel(totalNode.textContent);
      if (totalValue && totalValue !== '-') data.total = totalValue;
    }

    return data;
  }

  function sectionsFromCart(cart) {
    var id = window.CartAddToastDataSection;
    if (!id || !cart.sections) return null;
    return cart.sections[id] || null;
  }

  /**
   * cart.sections に裏方セクションが載っていなかった場合の後追い取得。
   * Section Rendering API を1回だけ叩き、開いているモーダルに差し込む。
   */
  function fetchSectionDataAndPatch() {
    var id = window.CartAddToastDataSection;
    if (!id || sectionFetching) return;
    sectionFetching = true;

    var url = window.location.pathname + '?sections=' + encodeURIComponent(id);
    fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (response) {
        return response.json();
      })
      .then(function (json) {
        sectionFetching = false;
        var data = parseSectionHtml(json && json[id]);
        if (!data) return;
        sectionData = data;
        patchSectionData();
      })
      .catch(function () {
        sectionFetching = false;
      });
  }

  // 描画済みのモーダルにブランド名・ポイント行を差し込む（後追い取得時に使う）
  function patchSectionData() {
    if (!root || !sectionData) return;

    root.querySelectorAll('.cart-add-toast__item[data-cat-line]').forEach(function (itemEl) {
      var key = itemEl.getAttribute('data-cat-line');
      var info = itemEl.querySelector('.cart-add-toast__info');
      if (!info) return;

      if (OPTIONS.showBrand && sectionData.brands[key] && !itemEl.querySelector('.cart-add-toast__brand')) {
        var brandRow = document.createElement('p');
        brandRow.className = 'cart-add-toast__brand';
        brandRow.textContent = sectionData.brands[key];
        info.insertBefore(brandRow, info.firstChild);
      }

      if (OPTIONS.showPoints && sectionData.points[key] && !itemEl.querySelector('.cart-add-toast__points')) {
        var row = document.createElement('p');
        row.className = 'cart-add-toast__meta cart-add-toast__points';
        row.innerHTML =
          '<span class="cart-add-toast__meta-label">' +
          escapeHtml(LABELS.points) +
          '</span>' +
          escapeHtml(sectionData.points[key]);

        var props = info.querySelector('.cart-add-toast__props');
        if (props) {
          info.insertBefore(row, props);
        } else {
          info.appendChild(row);
        }
      }
    });

    if (OPTIONS.showTotalPoints && sectionData.total) {
      var summary = root.querySelector('.cart-add-toast__summary');
      if (summary && !summary.querySelector('.cart-add-toast__summary-row--points')) {
        var pointsRow = document.createElement('div');
        pointsRow.className = 'cart-add-toast__summary-row cart-add-toast__summary-row--points';
        pointsRow.innerHTML =
          '<dt>' +
          escapeHtml(LABELS.summaryPoints) +
          '</dt><dd>' +
          escapeHtml(sectionData.total) +
          '</dd>';
        var goal = summary.querySelector('.cart-add-toast__goal');
        if (goal) {
          summary.insertBefore(pointsRow, goal);
        } else {
          summary.appendChild(pointsRow);
        }
      }
    }
  }

  function renderItems(added) {
    var list = added.slice(0, OPTIONS.maxItemsToList);
    var hidden = added.length - list.length;

    // 前回描画分の「他 N 点」は先に破棄する（再表示時の重複防止）
    var staleMore = root.querySelector('.cart-add-toast__more');
    if (staleMore) staleMore.parentNode.removeChild(staleMore);

    itemsEl.innerHTML = list
      .map(function (entry) {
        var item = entry.item;
        var qty = entry.qty;
        var rows = [];

        if (OPTIONS.showUnitPrice) {
          var onSale = Number(item.original_price) > Number(item.final_price);
          var priceHtml =
            '<span class="cart-add-toast__price' +
            (onSale ? ' cart-add-toast__price--sale' : '') +
            '">' +
            escapeHtml(money(item.final_price)) +
            '<span class="cart-add-toast__price-tax">' +
            escapeHtml(LABELS.tax) +
            '</span></span>';
          if (onSale) {
            priceHtml +=
              '<span class="cart-add-toast__price-was">' + escapeHtml(money(item.original_price)) + '</span>';
          }
          rows.push(
            '<p class="cart-add-toast__meta"><span class="cart-add-toast__meta-label">' +
              escapeHtml(LABELS.price) +
              '</span>' +
              priceHtml +
              '</p>'
          );
        }

        if (OPTIONS.showQuantity) {
          rows.push(
            '<p class="cart-add-toast__meta"><span class="cart-add-toast__meta-label">' +
              escapeHtml(LABELS.quantity) +
              '</span>' +
              qty +
              '</p>'
          );
        }

        if (OPTIONS.showLineTotal && qty > 1) {
          rows.push(
            '<p class="cart-add-toast__meta"><span class="cart-add-toast__meta-label">' +
              escapeHtml(LABELS.lineTotal) +
              '</span>' +
              escapeHtml(money(Number(item.final_price) * qty)) +
              '</p>'
          );
        }

        if (OPTIONS.showPoints && sectionData && sectionData.points[item.key]) {
          rows.push(
            '<p class="cart-add-toast__meta cart-add-toast__points"><span class="cart-add-toast__meta-label">' +
              escapeHtml(LABELS.points) +
              '</span>' +
              escapeHtml(sectionData.points[item.key]) +
              '</p>'
          );
        }

        if (OPTIONS.showProperties) {
          var props = visibleProperties(item);
          if (props.length) {
            rows.push(
              '<ul class="cart-add-toast__props">' +
                props
                  .map(function (prop) {
                    return '<li>' + escapeHtml(prop.key) + '：' + escapeHtml(prop.value) + '</li>';
                  })
                  .join('') +
                '</ul>'
            );
          }
        }

        var url = item.url || cartUrl();
        var image = item.image ? thumbUrl(item.image, 240) : '';
        var name = displayName(item);
        // ブランド名は裏方セクション由来。該当コレクションが無い商品は出さない（商品カードと同じ）
        var brandName = OPTIONS.showBrand && sectionData ? sectionData.brands[item.key] || '' : '';

        return [
          '<li class="cart-add-toast__item" data-cat-line="' + escapeHtml(item.key) + '">',
          '  <a class="cart-add-toast__thumb" href="' + escapeHtml(url) + '" tabindex="-1" aria-hidden="true">',
          image
            ? '    <img src="' +
              escapeHtml(image) +
              '" alt="" width="240" height="240" loading="lazy" decoding="async">'
            : '',
          '  </a>',
          '  <div class="cart-add-toast__info">',
          brandName ? '    <p class="cart-add-toast__brand">' + escapeHtml(brandName) + '</p>' : '',
          '    <a class="cart-add-toast__name" href="' + escapeHtml(url) + '">' + escapeHtml(name) + '</a>',
          rows.join(''),
          '  </div>',
          '</li>'
        ].join('');
      })
      .join('');

    if (hidden > 0) {
      var more = document.createElement('p');
      more.className = 'cart-add-toast__more';
      more.textContent = LABELS.more.replace('{count}', String(hidden));
      itemsEl.parentNode.insertBefore(more, itemsEl.nextSibling);
    }
  }

  /**
   * カートの点数（ご購入特典として自動追加された line item を除く）。
   *
   * 判定は sections/main-cart.liquid の checkout_item_count
   * （「レジに進む（n個の商品）」のラベル）と同一定義に揃えている：
   *   ・properties._bonus_block_id が付いている line item のみ除外する
   *   ・ギフト包装は明細に出る購入品なので除外しない
   *   ・0 円かどうかは見ない（通知を出すか否かの判定 isBonusItem() とは別基準）
   * そのためこの点数はカートページの「レジに進む（n個の商品）」と一致し、
   * ヘッダーのカートバッジ（cart.item_count そのまま＝特典を含む）とは一致しない。
   */
  function countableItemCount(cart) {
    if (!OPTIONS.excludeBonusFromCount) return Number(cart.item_count || 0);
    if (!cart.items || !cart.items.length) return Number(cart.item_count || 0);

    return cart.items.reduce(function (sum, item) {
      var props = item.properties || {};
      if (props._bonus_block_id) return sum;
      return sum + (Number(item.quantity) || 0);
    }, 0);
  }

  function renderSummary(cart) {
    if (!OPTIONS.showCartSummary && !OPTIONS.showFreeShippingGoal && !OPTIONS.showTotalPoints) {
      summaryEl.innerHTML = '';
      return;
    }

    var parts = [];

    if (OPTIONS.showCartSummary) {
      parts.push(
        '<div class="cart-add-toast__summary-row"><dt>' +
          escapeHtml(LABELS.summaryCount) +
          '</dt><dd>' +
          countableItemCount(cart) +
          escapeHtml(LABELS.summaryCountUnit) +
          '</dd></div>'
      );
      parts.push(
        '<div class="cart-add-toast__summary-row"><dt>' +
          escapeHtml(LABELS.summarySubtotal) +
          '</dt><dd>' +
          escapeHtml(money(cart.items_subtotal_price)) +
          '</dd></div>'
      );
      var cartDiscount = cartLevelDiscount(cart);
      if (cartDiscount > 0) {
        parts.push(
          '<div class="cart-add-toast__summary-row cart-add-toast__summary-row--discount"><dt>' +
            escapeHtml(LABELS.summaryDiscount) +
            '</dt><dd>-' +
            escapeHtml(money(cartDiscount)) +
            '</dd></div>'
        );
        parts.push(
          '<div class="cart-add-toast__summary-row cart-add-toast__summary-row--total"><dt>' +
            escapeHtml(LABELS.summaryTotal) +
            '</dt><dd>' +
            escapeHtml(money(cart.total_price)) +
            '</dd></div>'
        );
      }
    }

    if (OPTIONS.showTotalPoints && sectionData && sectionData.total) {
      parts.push(
        '<div class="cart-add-toast__summary-row cart-add-toast__summary-row--points"><dt>' +
          escapeHtml(LABELS.summaryPoints) +
          '</dt><dd>' +
          escapeHtml(sectionData.total) +
          '</dd></div>'
      );
    }

    var goalHtml = OPTIONS.showFreeShippingGoal ? buildGoalHtml(cart) : '';

    if (!parts.length && !goalHtml) {
      summaryEl.innerHTML = '';
      return;
    }

    summaryEl.innerHTML =
      '<dl class="cart-add-toast__summary">' + parts.join('') + goalHtml + '</dl>';

    // プログレスバーは描画後に幅を当てて transition を効かせる
    var bar = summaryEl.querySelector('.cart-add-toast__goal-bar span');
    if (bar) {
      var percent = bar.getAttribute('data-percent') || '0';
      requestAnimationFrame(function () {
        bar.style.width = percent + '%';
      });
    }
  }

  /**
   * カート単位の割引額（cents）を返す。
   *
   * 小計に items_subtotal_price（＝行レベル割引の適用後）を使っているため、
   * ここで cart.total_discount（行レベル割引も含む総額）を引くと二重に引かれた
   * 表示になる。カート単位の割引だけを取り出し、
   *   items_subtotal_price − ここでの戻り値 = total_price
   * が成り立つようにする。
   */
  function cartLevelDiscount(cart) {
    var apps = cart.cart_level_discount_applications;
    if (apps && apps.length) {
      return apps.reduce(function (sum, app) {
        return sum + (Number(app.total_allocated_amount) || 0);
      }, 0);
    }
    // 配列が無い場合の保険（差額から逆算する）
    var diff = Number(cart.items_subtotal_price || 0) - Number(cart.total_price || 0);
    return diff > 0 ? diff : 0;
  }

  function buildGoalHtml(cart) {
    var minimum = parseFloat(CONFIG.freeShippingMinimum);
    if (!minimum || isNaN(minimum)) return '';

    var rate = 1;
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) {
      rate = Number(window.Shopify.currency.rate) || 1;
    }

    var goal = minimum * rate; // 主単位
    if (goal <= 0) return '';

    var current = Number(cart.items_subtotal_price || 0) / 100; // 主単位
    var remaining = goal - current;
    var percent = Math.max(0, Math.min(100, (current / goal) * 100));

    var text = '';
    var doneClass = '';
    if (remaining > 0) {
      text = LABELS.goalRemaining.replace('{amount}', '<strong>' + escapeHtml(money(remaining * 100)) + '</strong>');
    } else {
      text = escapeHtml(LABELS.goalDone);
      doneClass = ' cart-add-toast__goal--done';
    }

    return [
      '<div class="cart-add-toast__goal' + doneClass + '">',
      '  <p class="cart-add-toast__goal-text">' + text + '</p>',
      '  <div class="cart-add-toast__goal-bar"><span data-percent="' + percent.toFixed(1) + '"></span></div>',
      '</div>'
    ].join('');
  }

  /* ============================================================
     表示 / 非表示
  ============================================================ */
  function show(added, cart) {
    buildRoot();

    // ブランド名・ポイントは追加リクエストのレスポンス（cart.sections）から取れれば同期で使う
    var needsSectionData = OPTIONS.showBrand || OPTIONS.showPoints || OPTIONS.showTotalPoints;
    if (needsSectionData) {
      sectionData = parseSectionHtml(sectionsFromCart(cart));
    } else {
      sectionData = null;
    }

    renderItems(added);
    renderSummary(cart);

    // 取れなかった場合だけ Section Rendering API で後追い取得して差し込む
    if (needsSectionData && !sectionData) {
      fetchSectionDataAndPatch();
    }

    if (bodyEl) bodyEl.scrollTop = 0;
    if (panelEl) {
      panelEl.classList.remove('is-dragging');
      panelEl.style.transform = '';
    }

    if (!root.classList.contains('is-open')) {
      lastFocused = document.activeElement;
      document.body.classList.add('body-no-scrollbar');
      // reflow を挟んで開くアニメーションを確実に発火させる
      void root.offsetWidth;
      root.classList.add('is-open');

      var primary = root.querySelector('.cart-add-toast__btn--primary');
      if (primary) {
        requestAnimationFrame(function () {
          try {
            primary.focus({ preventScroll: true });
          } catch (e) {
            primary.focus();
          }
        });
      }
    }
  }

  function hide() {
    if (!root || !root.classList.contains('is-open')) return;
    root.classList.remove('is-open');
    document.body.classList.remove('body-no-scrollbar');
    if (panelEl) {
      panelEl.classList.remove('is-dragging');
      panelEl.style.transform = '';
    }
    if (lastFocused && typeof lastFocused.focus === 'function') {
      try {
        lastFocused.focus({ preventScroll: true });
      } catch (e) {
        /* noop */
      }
    }
    lastFocused = null;
  }

  /* ============================================================
     SP: 下スワイプで閉じる
     - パネル内スクロール領域が最上部にある時だけドラッグを開始する
       （リストを上下に読む操作を邪魔しないため）
     - 10px 以上動いたらその後の click を 1 回抑止する
       （ボタン上から引き下げた時に押下扱いにならないように）
  ============================================================ */
  function setupSwipe() {
    var startY = 0;
    var startTime = 0;
    var delta = 0;
    var dragging = false;
    var candidate = false;
    var suppressClick = false;

    function canStart(target) {
      if (!isMobile()) return false;
      if (target && target.closest && target.closest('.cart-add-toast__handle')) return true;
      if (bodyEl && bodyEl.contains(target)) {
        return bodyEl.scrollTop <= 0;
      }
      return true;
    }

    panelEl.addEventListener(
      'touchstart',
      function (event) {
        if (event.touches.length !== 1) return;
        candidate = canStart(event.target);
        if (!candidate) return;
        startY = event.touches[0].clientY;
        startTime = Date.now();
        delta = 0;
        dragging = false;
      },
      { passive: true }
    );

    panelEl.addEventListener(
      'touchmove',
      function (event) {
        if (!candidate || event.touches.length !== 1) return;
        var current = event.touches[0].clientY - startY;
        if (current <= 0) {
          // 上方向は通常のスクロールに任せる
          if (dragging) {
            delta = 0;
            panelEl.style.transform = 'translateY(0px)';
          }
          return;
        }
        if (!dragging && current < 6) return;

        dragging = true;
        delta = current;
        panelEl.classList.add('is-dragging');
        // 引き下げに抵抗感を付ける（引きすぎを緩和）
        var offset = delta > 240 ? 240 + (delta - 240) * 0.4 : delta;
        panelEl.style.transform = 'translateY(' + offset + 'px)';
        if (event.cancelable) event.preventDefault();
      },
      { passive: false }
    );

    function endDrag() {
      if (!candidate) return;
      candidate = false;
      if (!dragging) return;

      var elapsed = Math.max(1, Date.now() - startTime);
      var velocity = delta / elapsed;
      var shouldClose = delta > SWIPE_CLOSE_DISTANCE || velocity > SWIPE_CLOSE_VELOCITY;

      if (delta > 10) suppressClick = true;

      panelEl.classList.remove('is-dragging');
      panelEl.style.transform = '';
      dragging = false;
      delta = 0;

      if (shouldClose) hide();
    }

    panelEl.addEventListener('touchend', endDrag, { passive: true });
    panelEl.addEventListener('touchcancel', endDrag, { passive: true });

    panelEl.addEventListener(
      'click',
      function (event) {
        if (!suppressClick) return;
        suppressClick = false;
        event.preventDefault();
        event.stopPropagation();
      },
      true
    );
  }

  /* ============================================================
     追加行の判定
  ============================================================ */
  function detectAddedItems(cart) {
    var added = [];

    if (snapshot) {
      cart.items.forEach(function (item) {
        var before = snapshot[item.key] || 0;
        var diff = Number(item.quantity) - before;
        if (diff > 0) {
          added.push({ item: item, qty: diff });
        }
      });
      return added;
    }

    // スナップショット未確立時のフォールバック（/cart/add.js のレスポンスを使う）
    if (pendingAdd) {
      var wanted = {};
      pendingAdd.forEach(function (entry) {
        if (entry && entry.key) wanted[entry.key] = Number(entry.quantity) || 1;
      });
      cart.items.forEach(function (item) {
        if (Object.prototype.hasOwnProperty.call(wanted, item.key)) {
          var qty = Math.min(wanted[item.key], Number(item.quantity) || 1);
          added.push({ item: item, qty: Math.max(1, qty) });
        }
      });
    }

    return added;
  }

  function handleCartUpdate(data) {
    if (!data || !data.cart || !data.cart.items) return;

    var cart = data.cart;
    var added = detectAddedItems(cart);

    // スナップショットは判定後に必ず更新する
    snapshot = buildSnapshot(cart);
    pendingAdd = null;
    if (pendingAddTimer) {
      clearTimeout(pendingAddTimer);
      pendingAddTimer = null;
    }

    if (!added.length) return;

    var visible = added.filter(function (entry) {
      return !isBonusItem(entry.item);
    });
    if (!visible.length) return;

    show(visible, cart);
  }

  /* ============================================================
     /cart/add.js レスポンスの控え
  ============================================================ */
  function handleProductAdded(event) {
    var payload = event && event.detail ? event.detail.product : null;
    if (!payload) return;

    var entries = [];
    if (payload.items && payload.items.length) {
      entries = payload.items;
    } else if (payload.key) {
      entries = [payload];
    }
    if (!entries.length) return;

    pendingAdd = entries;
    if (pendingAddTimer) clearTimeout(pendingAddTimer);
    // cartUpdate が来ないケースで残り続けないよう自動破棄する
    pendingAddTimer = setTimeout(function () {
      pendingAdd = null;
      pendingAddTimer = null;
    }, 5000);
  }

  /* ============================================================
     初期スナップショット
  ============================================================ */
  function readCartCountFromDom() {
    // 注意: バッジの点数はご購入特典の自動追加分を除いた値
    //（snippets/cart-count-value.liquid / assets/cart-count-bonus-exclude.js）。
    // そのため「0 だが実際は特典だけ入っている」ケースがあり得る。
    // その場合は空と誤認せず、不明（null）にして /cart.js での補完に回す。
    var hasItems = document.documentElement.classList.contains('cart-has-items');
    var candidates = document.querySelectorAll('cart-count, .cart-count');
    for (var i = 0; i < candidates.length; i++) {
      var text = (candidates[i].textContent || '').replace(/[^0-9]/g, '');
      if (text !== '') {
        var n = parseInt(text, 10);
        if (isNaN(n)) continue;
        if (n === 0 && hasItems) return null;
        return n;
      }
    }
    if (!hasItems) return 0;
    return null;
  }

  function scheduleIdle(callback) {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout: 3000 });
    } else {
      window.setTimeout(callback, 2500);
    }
  }

  function setupInitialSnapshot() {
    if (snapshot) return;

    var domCount = readCartCountFromDom();
    if (domCount === 0) {
      snapshot = {};
      return;
    }

    // 空でない（または不明な）場合のみ、LCP 後の idle で 1 回だけ取得する
    scheduleIdle(function () {
      if (snapshot) return;
      fetch(cartUrl() + '.js', {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          if (!snapshot && cart && cart.items) {
            snapshot = buildSnapshot(cart);
          }
        })
        .catch(function () {
          /* 失敗時は pendingAdd フォールバックに任せる */
        });
    });
  }

  /* ============================================================
     初期化（FoxTheme.pubsub 読込待ち）
  ============================================================ */
  document.addEventListener('product-ajax:added', handleProductAdded);

  function setupPubSubListener() {
    if (
      window.FoxTheme &&
      FoxTheme.pubsub &&
      typeof FoxTheme.pubsub.subscribe === 'function' &&
      FoxTheme.pubsub.PUB_SUB_EVENTS
    ) {
      FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, handleCartUpdate);
      setupInitialSnapshot();
      return true;
    }
    return false;
  }

  if (!setupPubSubListener()) {
    var retryCount = 0;
    var retryInterval = setInterval(function () {
      retryCount++;
      if (setupPubSubListener() || retryCount > 50) {
        clearInterval(retryInterval);
      }
    }, 100);
  }
})();